import { FC, ReactElement, memo } from 'react';
import { MealItemEditModalFormDefaultSwitcher } from '../../components/MealItemEditModalFormDefaultSwitcher/MealItemEditModalFormDefaultSwitcher';
import { MealItemEditModalFormHeader } from '../../components/MealItemEditModalFormHeader/MealItemEditModalFormHeader';
import { MealItemEditModalFormItemsPicker } from '../../components/MealItemEditModalFormItemsPicker/MealItemEditModalFormItemsPicker';
import { MealItemEditModalFormPriceBlock } from '../../components/MealItemEditModalFormPriceBlock/MealItemEditModalFormPriceBlock';

export const MealItemEditModalForm: FC = memo((): ReactElement => {
  return (
    <div className="meal-edit-modal__form">
      <MealItemEditModalFormHeader />
      <MealItemEditModalFormItemsPicker />
      <MealItemEditModalFormPriceBlock />
      <MealItemEditModalFormDefaultSwitcher />
    </div>
  );
});
